module.exports = __webpack_public_path__ + "static/img/A91.da6d3c92.jpg";